import ProjectPreview1 from "./projectPreview0.png";
import ProjectPreview2 from "./projectPreview1.png";

export const ProjectPreviewImages = [ProjectPreview1, ProjectPreview2];
